export class DataRequestField {
  constructor(
    public requestedStartTime: string,
    public requestedEndTime: string,
    public requestedCameraNames: string) { }
}
